import { render, staticRenderFns } from "./argumentForm.vue?vue&type=template&id=3fe08bb9&scoped=true"
import script from "./argumentForm.vue?vue&type=script&lang=js"
export * from "./argumentForm.vue?vue&type=script&lang=js"
import style0 from "./argumentForm.vue?vue&type=style&index=0&id=3fe08bb9&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe08bb9",
  null
  
)

export default component.exports